import React from 'react';
import { isEmpty } from 'lodash';

import { COLUMN_1 } from 'Components/frameworks/card/Card.constants';

import { Card } from 'Components/frameworks/card/Card';
import { Sheet } from 'Components/frameworks/sheet/Sheet';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';

export const TeaserCardsLayer = ({ image, title, description = '', blocks = [] }) => (
  <Sheet immersive={{ url: image }}>
    {!!title && (
      <Title className="mb-30" theme="title-brand-n0">
        {title}
      </Title>
    )}
    {!!description && <Text className="mb-30" text={description} />}
    {!isEmpty(blocks) && (
      <div className="grid grid-cols-1 gap-20 sm:grid-cols-2">
        {blocks.map(({ title: blockTitle, text: blockText }, index) =>
          blockTitle && blockText ? (
            <Card
              heading={{ hLevel: 3, title: blockTitle }}
              key={index}
              layout={COLUMN_1}
              text={{ text: blockText }}
            />
          ) : null,
        )}
      </div>
    )}
  </Sheet>
);
